import { useMemo } from 'react';
import { scaleTime } from '@visx/scale';
import { useResizeObserver } from './useResizeObserver';
import { useSelector } from 'react-redux';
import { DEFAULT_TIMELINE_WINDOW } from '../constants';

const useTimescale = (now, ref, options = {}) => {
  const { TIMELINE_WINDOW } = useSelector((state) => state.api.flags);
  if (!TIMELINE_WINDOW) console.warn('[useTimescale] TIMELINE_WINDOW flag not loaded, using default');
  const { clamp = false, time = TIMELINE_WINDOW || DEFAULT_TIMELINE_WINDOW } = options;
  const [width, height = 0] = useResizeObserver(ref);

  const dateScale = useMemo(
    () =>
      scaleTime({
        range: [0, width],
        domain: [now.minus(time), now],
        clamp,
      }),
    [width, now]
  );

  return [dateScale, width, height];
};

export default useTimescale;
